const RETRY_API_CALL_NUMBER = 10;
const RETRY_API_CALL_INIT_DELAY = 3000;
const RETRY_API_CALL_INCREMENT = 1.8;
const API_CALL_TIMEOUT = 60000;

export { RETRY_API_CALL_NUMBER, RETRY_API_CALL_INIT_DELAY, RETRY_API_CALL_INCREMENT, API_CALL_TIMEOUT };

export const API_CALLS = {
  GET_ACTIVE_OFFERS: 'getActiveOffers',
  GET_AGENTS: 'getAgents',
  GET_STUDENT_RECORD: 'getStudentRecord',
  GET_STUDENT_DOCS: 'getStudentDocs',
  GET_STUDENT_FIN_DOCS: 'getStudentFinDocs',
  GET_STUDENT_FOLLOW_UP_DOCS: 'getStudentFollowUpDocs',
  GET_COURSES: 'getCourses',
  GET_STUDENT_RECORDED_INTERVIEWS: 'getStudentRecordedInterviews'
};

export const LOCKED_SECTION_SUMMARY = `You can no longer edit this section as your data and documents are processed. If you need to make any urgent edits, please contact the institution using the messaging function below.`;

export const PASSWORD_FAILURE_MSG = 'Failed to change password, please try again later.';
